var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 157,
    viewBox: "0 0 158 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.25 78.5H17.7498",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.714 97.0154L106.492 108.237",
    stroke: "#4C5F71",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.714 108.237L106.492 97.0151",
    stroke: "#4C5F71",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8812 36.2988L17.75 78.5V115.25C17.75 118.499 19.0406 121.615 21.3379 123.912C23.6352 126.209 26.7511 127.5 30 127.5H128C131.249 127.5 134.365 126.209 136.662 123.912C138.959 121.615 140.25 118.499 140.25 115.25V78.5L119.119 36.2988C118.105 34.2578 116.541 32.5403 114.604 31.3392C112.667 30.1382 110.434 29.5012 108.155 29.5H49.845C47.566 29.5012 45.3325 30.1382 43.3956 31.3392C41.4588 32.5403 39.8954 34.2578 38.8812 36.2988V36.2988Z",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.25 103H42.3112",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.75 103H66.8113",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/Server.77bd695fa85a54640073077acd8096dd.svg";
export { ForwardRef as ReactComponent };